import React from 'react';
import { usePlatformBranding } from '../../contexts/PlatformBrandingContext';

/**
 * The One Manager platform's logo and name, as its admin sets them (hub contract §3.1): on the
 * sign-in page and at the top of the sidebar. `tone` is the background it sits on.
 */
export default function PlatformLogo({ size = 'md', tone = 'dark', showName = true, className = '', textClassName }) {
  const platform = usePlatformBranding();
  const { mode, imageUrl, imageDarkUrl, text, alt } = platform.logo || {};
  const image = tone === 'dark' ? imageDarkUrl || imageUrl : imageUrl;
  const height = size === 'lg' ? 'h-12' : size === 'sm' ? 'h-7' : 'h-9';
  const textSize = size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-base' : 'text-lg';
  const textColor = textClassName ?? (tone === 'dark' ? 'text-white' : 'text-gray-900');
  const name = text || platform.name;

  if (mode === 'image' && image) {
    return <img src={image} alt={alt || platform.name} className={`${height} w-auto max-w-full object-contain ${className}`} />;
  }
  return (
    <span className={`inline-flex min-w-0 items-center gap-2.5 ${className}`}>
      {mode === 'image-text' && image ? (
        <img src={image} alt="" className={`${height} w-auto shrink-0 object-contain`} />
      ) : mode !== 'text' ? (
        <span
          className={`${height} aspect-square shrink-0 rounded-lg flex items-center justify-center font-bold text-white`}
          style={{ background: platform.primaryColor }}
          aria-hidden="true"
        >
          {platform.name.slice(0, 1).toUpperCase()}
        </span>
      ) : null}
      {showName && <span className={`${textSize} truncate font-bold leading-tight ${textColor}`}>{name}</span>}
    </span>
  );
}
